export default __webpack_public_path__ + "static/media/yellowBigDiary.0c314f40.png";